import jQuery from "jquery";
// ドルマークに参照を代入(慣習的な $ を使うため)
const $ = jQuery;

//スマホの時の画面の高さを動的に取得
const height = window.innerHeight;
document.documentElement.style.setProperty('--vh', height / 100 + 'px');

const W = window.innerWidth;

const mediaQueryList = window.matchMedia('(min-width: 768px)');
const Body = $('body');

const listener = (event) => {
  // リサイズ時に行う処理
  const hamburgerBtn = $('.hamburger-btn');
  if (event.matches) {
    // 768px以上
    hamburgerBtn.on('click', function () {
      if (!Body.hasClass('is-menu-open')) {
        Body.addClass('is-menu-open');
      } else {
        Body.removeClass('is-menu-open');
      }
    });

  } else {
    // 768px未満
    $('.hamburger-btn').each(function () {
      const $obj = new Hammer(this);
      $obj.get('tap').set({
        enable: true
      });
      $obj.on('tap', function () {
        if (!Body.hasClass('is-menu-open')) {
          Body.addClass('is-menu-open');
        } else {
          Body.removeClass('is-menu-open');
        }
      });
    });

  }
};

mediaQueryList.addEventListener("change", listener);
listener(mediaQueryList);


//スクロールメニュー
if (W < 768) {
  if (document.querySelector('.category-menu') != null) {
    document.addEventListener("DOMContentLoaded", () => {
      const catMenuWidth = document.querySelector('.category-menu').clientWidth;
      const catMenuListWidth = document.querySelector('.category-menu__list').scrollWidth;
      const catMenuList = document.querySelector('.category-menu__list');
      const diff = parseInt(catMenuListWidth - catMenuWidth);
      const catMenuArrow = document.querySelector('.category-menu-arrow');
      catMenuArrow.addEventListener("click", (e) => {
        catMenuList.scrollBy({
          left: diff,
          behavior: "smooth"
        });
      });
      let startX = 0;
      catMenuList.addEventListener("touchstart", (e) => {
        startX = e.touches[0].clientX;
      });
      catMenuList.addEventListener("touchmove", (e) => {
        const currentX = e.changedTouches[0].clientX;
        const diffX = startX - currentX;
        catMenuList.scrollBy(diffX, 0);
        startX = currentX;
      });
    });
  }
}